import type { Dayjs } from 'dayjs';

import { ETimeDimension } from '~/core/gemxql/types';

export const getTimeDimensionByDate = (startDate: Dayjs, endDate: Dayjs): ETimeDimension => {
  const durationInDays = endDate.diff(startDate, 'day');

  if (durationInDays <= 3) return ETimeDimension.HOUR;
  if (durationInDays <= 93) return ETimeDimension.DAY;
  return ETimeDimension.MONTH;
};
